import { Component, Input, NgZone, TemplateRef, Inject } from '@angular/core';
import { PoolBid } from 'src/app/models/pool/pool-data.model';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TuiAlertService, TuiDialogService } from '@taiga-ui/core';
declare var moment: any;

@Component({
  selector: 'app-pool-manager-bids-table',
  standalone: false,
  templateUrl: './pool-manager-bids-table.component.html',
  styleUrls: ['./pool-manager-bids-table.component.css'],
})
export class PoolManagerBidsTableComponent {
  @Input() pooldata: PoolBid[] = [];
  readonly columns = [
    'check',
    'price',
    'counterOffer',
    'margen',
    'driver',
    'date',
    'hour',
    'status',
    'actions',
  ];
  readonly sizes = ['l', 'm', 's'] as const;
  size = this.sizes[0];

  select_all_bids: boolean = false;
  select_bid: boolean = false;
  showBildButtons: boolean = false;
  openedDropdownId: number | null = null;
  modalRef?: BsModalRef;
  acceptedDriver: string = '';
  rejectedDriver: string = '';
  selectedMap: { [id: number]: boolean } = {};

  constructor(
    public hs: HistoryServicesService,
    private modalService: BsModalService,
    @Inject(TuiAlertService) private readonly alertService: TuiAlertService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService
  ) {}

  ngOnInit(): void {
    this.pooldata.forEach((item, index) => {
      if (!(index in this.selectedMap)) {
        this.selectedMap[index] = false;
      }
    });
  }

  toggleDropdown(index: number): void {
    this.openedDropdownId = this.openedDropdownId === index ? null : index;
  }

  openModaAceptBid(
    templateModalAceptBid: TemplateRef<void>,
    name: string
  ): void {
    this.modalRef = this.modalService.show(
      templateModalAceptBid,
      Object.assign(
        {
          ignoreBackdropClick: false,
        },
        { class: 'gray modal-lg mt_10p' }
      )
    );
    this.openedDropdownId = null;
    this.acceptedDriver = name;
  }

  openModaRejectBid(
    templateModalRejectBid: TemplateRef<void>,
    name: string
  ): void {
    this.modalRef = this.modalService.show(
      templateModalRejectBid,
      Object.assign(
        {
          ignoreBackdropClick: false,
        },
        { class: 'gray modal-lg mt_10p' }
      )
    );
    this.openedDropdownId = null;
    this.rejectedDriver = name;
  }

  openModaRejectAllBid(templateModalRejectAllBid: TemplateRef<void>): void {
    this.modalRef = this.modalService.show(
      templateModalRejectAllBid,
      Object.assign(
        {
          ignoreBackdropClick: false,
        },
        { class: 'gray modal-lg mt_10p' }
      )
    );
    this.openedDropdownId = null;
  }

  aceptBild() {
    let message =
      'Puja de ' +
      this.acceptedDriver +
      ' aceptada. Se han rechazado automáticamente las demás ofertas.';
    this.showDepositAlert(message, '');
    this.modalRef?.hide();
  }

  rejectBild() {
    let message = 'Puja de ' + this.rejectedDriver + ' Rechazada.';
    this.showDepositAlert(message, '');
    this.modalRef?.hide();
  }

  rejectAllBild() {
    let message =
      'Se han rechazado todas las pujas activas. El servicio queda sin ofertas.';
    this.showDepositAlert(message, '');
    this.toggleAll();
    this.select_all_bids = false;
    this.modalRef?.hide();
  }

  showDepositAlert(title: string, message: string): void {
    this.alertService
      .open(message, {
        label: title,
        status: 'success',
        autoClose: true,
      })
      .subscribe({
        error: (err) => console.error('Alert error:', err),
      });
  }

  toggleSelection(id: number): void {
    // this.selectedMap[id] = !this.selectedMap[id];
    this.setBildButtons();
  }

  toggleAll(): void {
    const allSelected = this.pooldata.every(
      (item, index) => this.selectedMap[index]
    );
    this.pooldata.forEach((item, index) => {
      this.selectedMap[index] = !allSelected;
    });
    this.setBildButtons();
  }

  getSelectedItems(): any[] {
    return this.pooldata.filter((item, index) => this.selectedMap[index]);
  }

  setBildButtons() {
    let totalSeleccionados = Object.values(this.selectedMap).filter(
      (v) => v
    ).length;
    let totalBild = Object.values(this.pooldata).filter((v) => v).length;
    if (totalSeleccionados == totalBild) {
      this.showBildButtons = true;
    } else {
      this.showBildButtons = false;
    }
  }
}
